import { render, staticRenderFns } from "./Games.container.vue?vue&type=template&id=8d0f6434&scoped=true&"
import script from "./Games.container.vue?vue&type=script&lang=js&"
export * from "./Games.container.vue?vue&type=script&lang=js&"
import style0 from "./Games.container.vue?vue&type=style&index=0&id=8d0f6434&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d0f6434",
  null
  
)

export default component.exports